module.exports = __webpack_public_path__ + "img/logo.e50f7075.png";